module Core {
    export enum NotificationType {
        Animation = 1,
        Sondage = 2,
        AlerteSolde = 3,
        Paiement = 4,
		Ticket = 5,
    }
}